module.exports = __webpack_public_path__ + "static/img/cherry.e61e776a.webp";